import { useTranslation } from '@fluentsms/i18n';
import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import image from './image.svg';

const useStyles = makeStyles(() => ({
  inlineBlock: {
    display: 'inline-block',
  },
  centered: {
    textAlign: 'center',
  },
}));

export function NoResultsFound() {
  const { t } = useTranslation('componentLibrary');
  const classes = useStyles();

  return (
    <div className={[classes.centered, classes.inlineBlock].join(' ')}>
      <img src={image} alt={t('noResultsFound.title')} />
      <Typography variant="h4">{t('noResultsFound.title')}</Typography>
      <Typography variant="body1" color="secondary">
        {t('noResultsFound.description')}
      </Typography>
    </div>
  );
}
